locations-people
  .person(each="{opts.items}")
     span
       a.btn.icon-btn.btn-primary.waves-effect.waves-light.btn-sm(href="{edit_path}")
         i.feather.icon-edit
     span.name(data-ruby="{kana}") {name}
     span.tel
       | {tel}
       span.tel_ext(if="{tel_ext}") ({tel_ext})
  span
    a.btn.icon-btn.btn-primary.waves-effect.waves-light.btn-sm(href="{opts.new_path}")
      i.feather.icon-plus
  script(type="typescript").
    this.mixin('base');
  style(scoped).
    .person {
      margin-bottom: 2px;
      display: table
    }
    
    .person > span {
      display: table-col;
      padding-right: 1rem;
    }
    
    .name {
      margin: 15 0 0 1rem;
    }
    .tel {
      
    }
    .tel_ext {
      display: inline-block;
      margin-left: .5rem;
    }
